import {
  combineReducers,
  createReducer,
  PayloadAction,
} from "@reduxjs/toolkit";
import {
  appUserDataFail,
  appUserDataRequest,
  appUserDataSuccess,
  uploadCsvFileFail,
  uploadCsvFileRequest,
  uploadCsvFileSuccess,
} from "./actions";
import { canAccessAdminCenter } from "./access";
import { IAppUser } from "./types";

interface IAppUserInitialState {
  data?: IAppUser;
  isLoading: boolean;
  success: boolean;
  fail: boolean;
  authChecked: boolean;
}

const APP_USER_INITIAL_STATE: IAppUserInitialState = {
  data: undefined,
  isLoading: false,
  success: false,
  fail: false,
  authChecked: false,
};

const appUserDataReducer = createReducer(APP_USER_INITIAL_STATE, {
  [appUserDataRequest.type]: (state) => ({
    ...state,
    isLoading: true,
    success: false,
    fail: false,
  }),
  [appUserDataSuccess.type]: (state, { payload }: PayloadAction<IAppUser>) => {
    const timestamp = new Date().getTime();

    const updatedMemberships = payload.memberships.map((membership) => ({
      ...membership,
      orgLogoUrl: membership.orgLogoUrl
        ? `${membership.orgLogoUrl}?${timestamp}`
        : membership.orgLogoUrl,
      orgInfoUrl: membership.orgInfoUrl
        ? `${membership.orgInfoUrl}?${timestamp}`
        : membership.orgInfoUrl,
    }));

    const updatedPayload = {
      ...payload,
      memberships: updatedMemberships,
    };

    return {
      ...state,
      data: updatedPayload,
      isLoading: false,
      success: true,
      fail: false,
      authChecked: canAccessAdminCenter(updatedPayload),
    };
  },

  [appUserDataFail.type]: (state) => ({
    ...state,
    isLoading: false,
    success: false,
    fail: true,
    authChecked: false,
  }),

  [uploadCsvFileRequest.type]: (state) => ({
    ...state,
    isLoading: true,
    uploadSuccess: false,
    uploadError: null,
  }),
  [uploadCsvFileSuccess.type]: (state, action) => ({
    ...state,
    isLoading: false,
    uploadSuccess: true,
    uploadError: null,
    uploadedData: action.payload,
  }),
  [uploadCsvFileFail.type]: (state, action) => ({
    ...state,
    isLoading: false,
    uploadSuccess: false,
    uploadError: action.payload,
  }),
});

export interface IGeneralState {
  readonly general: IAppUserInitialState;
}

export default combineReducers<IGeneralState>({
  general: appUserDataReducer,
});
